module.exports = __webpack_public_path__ + "assets/asset_square.41add44a.svg";